import "styles/root.scss";

import { type FunctionComponent } from "preact";
import CookieDeclaration from "core/CookieDeclaration";
import SiteCookiesListEmbed from "core/SiteCookiesListEmbed";
import SiteCookiesTableEmbed from "core/SiteCookiesTableEmbed";
import { createPortal } from "helpers/portals";

const CookiesAndPolicyEmbeds: FunctionComponent<
  ICookiesAndPolicyEmbedsProps
> = ({ containers }) => {
  const [
    policyContainer,
    policyWithListContainer,
    cookiesTableContainer,
    cookiesListContainer,
  ] = containers;
  return (
    <>
      {!!policyContainer &&
        createPortal(<CookieDeclaration />, policyContainer)}
      {!!policyWithListContainer &&
        createPortal(
          <CookieDeclaration layout="alternate" />,
          policyWithListContainer
        )}
      {!!cookiesTableContainer &&
        createPortal(<SiteCookiesTableEmbed />, cookiesTableContainer)}
      {!!cookiesListContainer &&
        createPortal(<SiteCookiesListEmbed />, cookiesListContainer)}
    </>
  );
};

export interface ICookiesAndPolicyEmbedsProps {
  containers: [
    policyContainer: null | HTMLElement,
    policyListContainer: null | HTMLElement,
    cookiesTableContainer: null | HTMLElement,
    cookiesListContainer: null | HTMLElement
  ];
}

export default CookiesAndPolicyEmbeds;
